import React from "react";
import styled from "styled-components";

// The Create Groups info tooltip, shared by today's create row and Manage
// Groups as one list. Kept free of app imports: it is loaded while `utils`
// is still loading.

// Hover/focus tooltip on the "Create Groups:" info icon (Figma 4277-12498):
// light-purple bubble with an up-arrow, explaining Lesson vs Quick Groups.
export const CreateGroupsTip = styled.div`
  background: #eaeafc;
  border-radius: 20px;
  box-shadow: 0px 4px 12px rgba(14, 26, 49, 0.12);
  color: #00140b;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 400;
  left: 50%;
  letter-spacing: 0.25px;
  line-height: 22px;
  padding: 16px;
  position: absolute;
  text-align: left;
  top: calc(100% + 12px);
  transform: translateX(-50%);
  /* Override the nowrap inherited from Label so the copy wraps. */
  white-space: normal;
  width: 340px;
  word-break: break-word;
  z-index: 200;

  p {
    margin: 0;
  }
  p + p {
    margin-top: 16px;
  }
  strong {
    font-weight: 700;
  }

  &::before {
    border: 8px solid transparent;
    border-bottom-color: #eaeafc;
    bottom: 100%;
    content: "";
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
  }
`;

export const DEFAULT_LESSON_GROUPS_DETAIL =
  "align with your daily curriculum and with groups for core, prerequisite, and extension levels.";

// The tooltip's paragraphs; Manage Groups as one list adds warm-up groups.
export const CreateGroupsTipCopy = ({ lessonGroupsDetail, warmUpGroups = false }) => (
  <>
    <p><strong>Create Groups:</strong></p>
    <p>Create <strong>Lesson Groups</strong> to {lessonGroupsDetail}</p>
    <p>Create <strong>Quick Groups</strong> to instantly generate a standalone group code for targeted practice on a specific standard.</p>
    {warmUpGroups && (
      <p>Create <strong>Warm-Up Groups</strong> to get every student thinking and talking about math, with no prior instruction.</p>
    )}
  </>
);

